import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-inline-empty-state',
  standalone: true,
  imports: [TranslocoPipe],
  template: `
  <div class="d-flex align-items-center gap-1">
    <i class="ph-fill ph-info inline-empty-state-icon"></i>
    <span class="text-secondary fs-14">{{ message || ('common.noDataFound' | transloco) }}</span>
  </div>
  `,
  styles: `
    .inline-empty-state-icon {
      color: #FF7F00;
      font-size: 16px;
    }
  `
})
export class InlineEmptyStateComponent {
  @Input() message: string = '';
}
